<template>
  <v-carousel
    v-model="current"
    :show-arrows="false"
    hide-delimiters
    height="100%"
  >
    <v-carousel-item v-for="(family, i) in renderedFamilies" :key="i">
      <question-family
        :family="family"
        @goBack="goBack(i)"
        @goNext="goNext(i)"
      ></question-family>
    </v-carousel-item>
  </v-carousel>
</template>
<script>
import QuestionFamily from "./question-family.vue";
export default {
  components: {
    QuestionFamily,
  },
  data() {
    return {
      debounce: "",
    };
  },
  computed: {
    current: function () {
      if (this.$route.query.familyId) {
        return this.renderedFamilies.findIndex(
          (item) => item.familyId === Number(this.$route.query.familyId)
        );
      }
      return Number(this.$route.query.pos) || 0;
    },
    renderedFamilies: function () {
      return this.$store.getters["notesModule/getRenderedFamilies"] || [];
    },
    selectedTemplateNote() {
      return this.$store.state.notesModule.selectedTemplateNote;
    },
  },
  methods: {
    goBack: async function (index) {
      if (this.current) {
        var to = this.renderedFamilies[index - 1].familyId;

        clearTimeout(this.debounce);
        this.debounce = setTimeout(async () => {
          this.saveCurrentFamily(to);
        }, 1000);

        this.$router.push({
          name: "TemplateNote",
          query: { pos: this.current - 1 },
        });
      } else {
        this.$router.push({ name: "ReportsDashboard" });
      }
    },
    goNext: async function (index) {
      if (this.current === this.renderedFamilies.length - 1) {
        this.$store.commit("uxModule/setShowLoader", true);
        await this.$store.dispatch("notesModule/loadTemplateNote", {
          templateNoteId: this.selectedTemplateNote?.templateNoteId,
        });
        this.$store.dispatch("notesModule/validateRenderedFamilies");
        this.$store.commit("uxModule/setShowLoader", false);
        this.$router.push({ name: "ReviewQuestions" });
      } else {
        var to = this.renderedFamilies[index + 1].familyId;
        clearTimeout(this.debounce);
        this.debounce = setTimeout(async () => {
          this.saveCurrentFamily(to);
        }, 1000);

        this.$router.push({
          name: "TemplateNote",
          query: { pos: this.current + 1 },
        });
      }
    },
    async saveCurrentFamily(familyId) {
      await this.$store.dispatch("notesModule/saveCurrentFamily", {
        templateNoteId: this.selectedTemplateNote?.templateNoteId,
        familyId: familyId,
      });
    },
  },
};
</script>
